import {
  FontWeight, Grid, Spacing, SpacingName, TagName, Typography,
} from '@doveit/lego';
import React from 'react';
import * as styles from './FeatureBlock.style';

export interface FeatureBlockProps {
  title: {
    tag?: TagName,
    content: string,
  },
  subtitle?: string,
  highlight?: string,
  description?: string,
  inverted?: boolean,
  children: React.ReactNode,
}

const FeatureBlock: React.FC<FeatureBlockProps> = ({
  title,
  subtitle,
  highlight,
  description,
  inverted,
  children,
}) => (
  <Grid
    gutter={SpacingName.MEDIUM}
    addCSS={styles.grid(inverted)}
  >
    <Grid.Unit size={{ LG: 1 / 2 }}>
      <div
        css={styles.title}
        as={title.tag || 'h2'}
        dangerouslySetInnerHTML={{
          __html: title.content,
        }}
      />
      {subtitle && (
        <Spacing margin={[SpacingName.SMALLEST, 0, 0]}>
          <Typography.H2
            tagName="p"
            fontWeight={FontWeight.LIGHT}
          >
            {subtitle}
          </Typography.H2>
        </Spacing>
      )}
      {highlight && (
        <Spacing margin={[SpacingName.SMALL, 0, 0]}>
          <Typography.H3
            tagName="p"
            fontWeight={FontWeight.LIGHT}
          >
            {highlight}
          </Typography.H3>
        </Spacing>
      )}
      {description && (
        <Spacing margin={[SpacingName.SMALL, 0, 0]}>
          <Typography.H4
            tagName="p"
            fontWeight={FontWeight.LIGHT}
          >
            {description}
          </Typography.H4>
        </Spacing>
      )}
    </Grid.Unit>
    <Grid.Unit size={{ LG: 1 / 2 }}>
      {children}
    </Grid.Unit>
  </Grid>
);

export default FeatureBlock;
